import { getUrl, Request } from '../../request';

export const getLocationProvince = () => Request.get(getUrl('/api/v1/locations/province/'));

export const getLocationCities = (province_id) =>
  Request.get(getUrl('/api/v1/locations/city/'), {
    province_id
  });

export const getProvinces = () => Request.get(getUrl('/api/v1/locations/provinces/'));

export const getCities = (province_id) =>
  Request.get(getUrl('/api/v1/locations/cities/'), {
    province_id
  });

export const getRegions = (city_id) =>
  Request.get(getUrl('/api/v1/locations/region/'), {
    city_id
  });
